import { font, radius, shadow, tokens } from './marketingTokens';

/**
 * CSS variables for AI-Vis. Values come only from marketingTokens.js.
 */
export function getAiVisCssVars() {
  return {
    '--aivis-bg': tokens.graphite50,
    '--aivis-panel': tokens.white,
    '--aivis-surface': tokens.white,
    '--aivis-border': tokens.graphite200,
    '--aivis-border-brand': tokens.green200,
    '--aivis-border-subtle': tokens.graphite100,
    '--aivis-border-strong': tokens.graphite300,
    '--aivis-text': tokens.graphite800,
    '--aivis-text-body': tokens.graphite700,
    '--aivis-text-muted': tokens.graphite500,
    '--aivis-text-subtle': tokens.graphite400,
    '--aivis-accent': tokens.green700,
    '--aivis-accent-soft': tokens.green100,
    '--aivis-chip': tokens.green50,
    '--aivis-brand': tokens.green500,
    '--aivis-brand-strong': tokens.green600,
    '--aivis-auth-gradient': `linear-gradient(145deg, ${tokens.green50} 0%, ${tokens.white} 55%, ${tokens.graphite50} 100%)`,
    '--aivis-positive': tokens.positive500,
    '--aivis-positive-soft': tokens.positive100,
    '--aivis-positive-ink': tokens.positiveInk,
    '--aivis-caution': tokens.caution500,
    '--aivis-caution-soft': tokens.caution100,
    '--aivis-caution-ink': tokens.cautionInk,
    '--aivis-btn-on-accent': tokens.white,
    '--aivis-link': tokens.green700,
    '--aivis-emphasis': tokens.green800,
    '--aivis-danger': tokens.critical500,
    '--aivis-danger-soft': tokens.critical100,
    '--aivis-danger-ink': tokens.criticalInk,
    '--aivis-info': tokens.info500,
    '--aivis-info-soft': tokens.info100,
    '--aivis-info-ink': tokens.infoInk,
    '--aivis-new-campaign-bg': tokens.green500,
    '--aivis-new-campaign-hover': tokens.green600,
    '--aivis-new-campaign-icon': tokens.white,
    '--aivis-chart-1': tokens.green600,
    '--aivis-chart-2': tokens.info500,
    '--aivis-grid': tokens.graphite200,
    '--aivis-inverse': tokens.graphite800,
    '--aivis-overlay': 'rgba(29, 30, 31, 0.55)',
    '--aivis-white-soft': 'rgba(255, 255, 255, 0.4)',
    '--aivis-focus-ring': 'rgba(104, 138, 35, 0.18)',
    '--aivis-radius-sm': radius.sm,
    '--aivis-radius-md': radius.md,
    '--aivis-radius-lg': radius.lg,
    '--aivis-radius-pill': radius.pill,
    '--aivis-shadow-sm': shadow.sm,
    '--aivis-shadow-md': shadow.md,
    '--aivis-shadow-lg': shadow.lg,
    '--aivis-shadow-xl': shadow.xl,
    '--aivis-shadow-brand': shadow.brand,
    '--aivis-font-sans': font.sans,
    '--aivis-font-display': font.display,
  };
}
